<button mat-button
        #openButton
        [ngClass]="triggerClass"
        [style.line]
        cdkOverlayOrigin
        (click)="openOverlay()"
        #trigger="cdkOverlayOrigin">
  <span class="mat-form-field-label-wrapper"
        *ngIf="selectedField && label">
    <label class="mat-form-field-label d-block">
      {{label}}
    </label>
  </span>
  <div [ngClass]="{'mt-0025': label && selectedField && !clearable, 'is-clearable': clearable}"
       [ngStyle]="(label && selectedField && clearable) ? {'margin-top': '-.30rem'} : null">
    <span class="truncate">{{ selectedField?.name || label || 'Select Field' }}</span>
    <button mat-icon-button
            *ngIf="selectedField && clearable"
            (click)="$event.stopPropagation(); onItemSelected(null);"
            class="mat-clear-field">
      <mat-icon fontSet="fal"
                fontIcon="fa-times"></mat-icon>
    </button>
  </div>
  <div class="mat-select-arrow-wrapper">
    <div class="mat-select-arrow"></div>
  </div>
  <!-- <button mat-icon-button
          class="h-auto lh-normal"
          *ngIf="selectedField"
          (click)="$event.stopPropagation(); onItemSelected(null);">
    <mat-icon fontSet="fal"
              fontIcon="fa-times"></mat-icon>
  </button> -->
</button>

<ng-template cdkConnectedOverlay
             #overlay="cdkConnectedOverlay"
             (detach)="closeOverlay()"
             (backdropClick)="closeOverlay()"
             [cdkConnectedOverlayOffsetY]="cdkConnectedOverlayOffsetY"
             [cdkConnectedOverlayHasBackdrop]="true"
             [cdkConnectedOverlayBackdropClass]="'transparent-backdrop'"
             [cdkConnectedOverlayOrigin]="trigger"
             [cdkConnectedOverlayWidth]="triggerWidth$ | async"
             [cdkConnectedOverlayMinWidth]="'300px'"
             [cdkConnectedOverlayOpen]="isOpen">
  <!-- @JARROD: Probably not ideal to use the same triggerClasses for this as the select button -->
  <div class="pos-relative"
       [ngClass]="triggerClass">

    <button type="button"
            class="ab-overlay-close-button"
            (click)="closeOverlay()">
      <span><i class="fal fa-times"></i></span>
    </button>
    <app-field-search-inline class="d-block bg-color--white"
                             [filterOptionsFn]="filterOptionsFn"
                             [campaignId]="campaignId"
                             [hideReadonly]="hideReadonly"
                             [hideUniversal]="hideUniversal"
                             [tagTypes]="tagTypes"
                             [targetType]="targetType"
                             [targetTypeId]="targetTypeId"
                             [withTypeSelect]="withTypeSelect"
                             [multiple]="false"
                             [showCloseButton]="true"
                             (itemSelected)="onItemSelected($event)"></app-field-search-inline>

  </div>

</ng-template>
